import {GoogleButtonTypeEnum} from '../../../../../../../service/posts/posts-types';

export function isButtonLinkFieldVisible(buttonType?: GoogleButtonTypeEnum | null): boolean {
    return Boolean(buttonType && ![GoogleButtonTypeEnum.Unspecified, GoogleButtonTypeEnum.Call].includes(buttonType));
}
